import { createStore } from "vuex";

import authModule from './modules/auth.js';
import accountModule from './modules/account.js';

export default createStore({
  modules:{
    authModule: authModule,
    accountModule: accountModule
  },
  state: {
    pageContent: {
      title: "shopee",
      subtitle: "One-stop Online Market",
      copyright: "Copyright &copy; 2021. shopee. All Rights Reserved.",
    },
  },
  getters: {
    pageContent(state) {
      return state.pageContent;
    },
  },
  mutations: {

  },
  actions: {
  },
});
